<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="开票申请" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<!-- <el-form-item label="项目编码">
									<el-input v-model="searchForm.project_code" placeholder="请填写项目编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="项目名称">
									<el-input v-model="searchForm.project_name" placeholder="请填写项目名称" clearable></el-input>
								</el-form-item> -->
								<el-form-item label="开票编码">
									<el-input v-model="searchForm.invoice_code" placeholder="请填写开票编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="收票方">
									<el-input v-model="searchForm.shoupiaofang" placeholder="请填写收票方" clearable></el-input>
								</el-form-item>
								<el-form-item label="业务类型">
									<el-select v-model="searchForm.business_type" placeholder="请选择业务类型" @change="changeSearchType"
										clearable>
										<el-option v-for="item in options.business_type_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
									<div v-if="!searchForm.business_type"
										style="position: absolute;line-height: 16px;color: #f56c6c;font-size: 12px;">请先选择业务类型</div>
								</el-form-item>

								<el-form-item :label="searchForm.business_type == 2 ? '项目编码' : '执行编码'" v-if="searchForm.business_type">
									<el-input placeholder="请输入搜索内容" v-model="searchForm.execute_code" clearable></el-input>
								</el-form-item>
								<el-form-item label="所属客户" v-if="searchForm.business_type == 2">
									<el-select v-model="searchForm.customer_id" placeholder="请选择所属客户" clearable filterable remote
										reserve-keyword :remote-method="getCustomer">
										<el-option v-for="item in options.customer_id_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="所属供应商" v-if="searchForm.business_type == 1">
									<el-select v-model="searchForm.supplier_id" placeholder="请选择所属供应商" clearable filterable remote
										reserve-keyword :remote-method="getSupplier">
										<el-option v-for="item in options.supplier_id_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="发票类型">
									<el-select v-model="searchForm.invoice_type" placeholder="请选择发票类型" clearable>
										<el-option v-for="item in options.invoice_type_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="发票类目">
									<el-select v-model="searchForm.invoice_item" placeholder="请选择发票类目" clearable>
										<el-option v-for="item in options.invoice_item_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="状态">
									<el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="开票人">
									<el-input v-model="searchForm.open_invoice_user_name" placeholder="请填写开票人" clearable></el-input>
								</el-form-item>
								<el-form-item label="发票号">
									<el-input v-model="searchForm.invoice_number" placeholder="请填写发票号" clearable></el-input>
								</el-form-item>
								<el-form-item label="开票时间">
									<el-date-picker v-model="searchForm.open_invoice_time" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/resources/resources/invoiceopen')">
								<div>
									<el-button type="primary" size="mini" @click="addInvoiceOpen"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/invoiceopen')">开票申请</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" border stripe v-loading="tableloading" ref="table"
									highlight-current-row :height="tableHeight">
									<el-table-column fixed prop="invoice_code" label="开票编码" width="150">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.invoice_code }}</el-link>
										</template>
									</el-table-column>
									<el-table-column prop="open_type_txt" label="开具类型" width="100">
									</el-table-column>
									<el-table-column prop="business_type_txt" label="业务类型" width="80">
									</el-table-column>
									<el-table-column prop="public_name" label="所属客户/供应商" min-width="200">
									</el-table-column>
									<el-table-column prop="payment_date" label="预计回款时间" width="100">
									</el-table-column>
									<el-table-column prop="invoice_types" label="电子发票格式" width="100">
									</el-table-column>
									<el-table-column label="收票方信息" min-width="250">
										<template slot-scope="scope">
											<p style="font-weight: bold;">发票抬头：{{ scope.row.shoupiaofang }}</p>
											<p style="font-weight: bold;">发&nbsp;票&nbsp;率&nbsp;：{{ scope.row.invoice_type_txt }}</p>
											<p style="font-weight: bold;">发票类目：{{ scope.row.invoice_item_txt }}</p>
											<p style="font-weight: bold;">票面金额：{{ scope.row.open_price }}元</p>
										</template>
									</el-table-column>
									<el-table-column prop="uid_txt" label="申请人" width="80">
									</el-table-column>
									<!-- <el-table-column prop="open_price" label="申请开票金额(元)" width="120">
									</el-table-column> -->
									<el-table-column prop="count_invoice" label="关联发票数" width="100">
										<template slot-scope="scope">
											<el-popover placement="top-start" width="400" v-if="scope.row.count_invoice > 0" trigger="hover">
												<el-table :data="scope.row.invoice_entry_open_list" style="width: 100%;" border stripe
													highlight-current-row>
													<el-table-column width="300" property="invioce_number" label="发票编码"></el-table-column>
													<el-table-column width="100" property="invoice_price" label="关联金额(元)"></el-table-column>
												</el-table>
												<el-link type="primary" slot="reference" style="font-size: 12px;" :underline="false">{{
													scope.row.count_invoice }}</el-link>
											</el-popover>
											<span v-else>{{ scope.row.count_invoice }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="project_code_list" label="关联项目/执行" width="100">
										<template slot-scope="scope">
											<el-popover placement="top-start" width="400" v-if="scope.row.project_code_list.length > 0"
												trigger="hover">
												<el-table :data="scope.row.project_code_list" style="width: 100%;" border stripe
													highlight-current-row>
													<el-table-column width="180" property="project_code" label="项目/执行编码"></el-table-column>
													<el-table-column width="200" property="project_name" label="项目/资源名称"></el-table-column>
													<el-table-column width="100" property="price" label="开票金额"></el-table-column>
												</el-table>
												<el-link type="primary" slot="reference" style="font-size: 12px;"
													:underline="false">查看详情</el-link>
											</el-popover>
											<span v-else>暂无</span>
										</template>
									</el-table-column>
									<!-- 
									<el-table-column prop="invoice_item_txt" label="发票类目" width="180">
									</el-table-column>
									<el-table-column prop="invoice_type_txt" label="发票类型" width="100">
									</el-table-column> -->

									<el-table-column prop="uid_txt" label="添加人" width="80">
									</el-table-column>
									<el-table-column prop="open_invoice_time" label="开票时间" width="150">
									</el-table-column>
									<el-table-column prop="create_time" label="申请时间" width="150">
									</el-table-column>
									<el-table-column prop="open_invoice_uid_txt" label="开票人" width="80">
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" align="center" label="状态" width="80">
										<template slot-scope="scope">
											<span style="font-weight: bold;">{{ scope.row.status_txt }}</span>
										</template>
									</el-table-column>
									<el-table-column
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/submitopeninvice') || $parent.$parent.isAuthAction('admin/resources/resources/delopeninvice') || $parent.$parent.isAuthAction('admin/resources/resources/editopeninvice')"
										fixed="right" label="操作" min-width="140">
										<template slot-scope="scope">
											<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)"
												@click="editOpenInvoice(scope.row)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/editopeninvice')">编辑</el-button>
											<el-button :disabled="!(scope.row.status == 1)" @click="addConfirmForm(scope.row)" type="text"
												:size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/submitopeninvice')">提交审批</el-button>
											<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)" type="text"
												@click="handleDelete(scope.row)" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/delopeninvice')">删除申请</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--申请开票-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="80%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>申请开票</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="业务类型" prop="business_type">
						<el-radio-group v-model="addForm.business_type" @input="changeType()">
							<el-radio :label="1">返点收入</el-radio>
							<el-radio :label="2">项目收入</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="供应商" prop="supplier_id" v-if="addForm.business_type == 1">
						<el-select v-model="addForm.supplier_id" filterable remote :remote-method="getSupplier" clearable
							placeholder="请输入您要搜索的供应商名称" style='width: 100%;' @change="getSupplierlist()">
							<el-option v-for="item in options.supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="执行" prop="execute_ids" v-if="addForm.supplier_id && addForm.business_type == 1">
						<el-select v-model="addForm.execute_ids" multiple filterable remote :remote-method="getSupplierSearch"
							clearable placeholder="请输入您要搜索的执行" style='width: 100%;' @change="addInvoiceIds()">
							<el-option v-for="item in options.execute_ids_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<div style="padding-top: 8px; color: #F56C6C; font-size:13px;" v-if="invoice_tips">{{ invoice_tips }}</div>
					</el-form-item>
					<el-form-item label="客户" prop="customer_id" v-if="addForm.business_type == 2">
						<el-select v-model="addForm.customer_id" filterable remote :remote-method="getCustomer" clearable
							placeholder="请输入您要搜索的客户名称" style='width: 100%;' @change="getProjectlist()">
							<el-option v-for="item in options.customer_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="项目" prop="project_ids" v-if="addForm.customer_id && addForm.business_type == 2">
						<el-select v-model="addForm.project_ids" multiple filterable remote :remote-method="getProjectlistSearch"
							clearable placeholder="请输入您要搜索的项目名称" style='width: 100%;' @change="addInvoiceIds()">
							<el-option v-for="item in options.project_ids_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<div style="padding-top: 8px; color: #F56C6C; font-size:13px;" v-if="invoice_tips">{{ invoice_tips }}</div>
					</el-form-item>
					<el-row v-for="(item, index) in invoice_open_list" :key="index"
						v-if="invoice_open_list.length > 0 && addForm.invoice_open_list[0].code">
						<el-form-item style="margin-bottom: 0;">
							<el-col :span="12">
								<el-form-item :label="addForm.business_type == 1 ? '执行编码:' : '项目编码:'" label-width="78px">
									<el-input v-model="addForm.invoice_open_list[index].code" clearable disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="申请开票金额:" label-width="128px" :prop="`invoice_open_list[${index}].open_price`"
									:rules="[{ required: true, validator: validatorLrId, trigger: 'blur' }]">
									<el-input v-model="addForm.invoice_open_list[index].open_price" placeholder="请填写申请开票金额"></el-input>
								</el-form-item>
							</el-col>
						</el-form-item>
					</el-row>
					<el-form-item v-if="invoice_open_list.length > 0 && addForm.invoice_open_list[0].code">
						<el-col :span="12" style="margin-right:10px">
							<el-form-item label="申请开票金额合计:" label-width="135px">
								<span>{{ returnCost() }}元</span>
							</el-form-item>
						</el-col>
					</el-form-item>
					<el-form-item label="开具类型" prop="open_type">
						<el-radio-group v-model="addForm.open_type">
							<el-radio :label="1">先款后票</el-radio>
							<el-radio :label="2">先票后款</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="预计回款时间" prop="payment_date" v-if="addForm.open_type == 2">
						<el-date-picker type="date" placeholder="请选择签订日期" v-model="addForm.payment_date" style="width: 100%;"
							format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item label="发票类目" prop="invoice_item">
						<el-select v-model="addForm.invoice_item" filterable remote clearable placeholder="请输入您要搜索的发票类目"
							style='width: 100%;'>
							<el-option v-for="item in options.invoice_item_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="电子发票格式" prop="invoice_types">
						<el-checkbox-group v-model="addForm.invoice_types">
							<el-checkbox-button v-for="city in options.cityOptions" :label="city" :key="city">{{ city
							}}</el-checkbox-button>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="发票类型" prop="invoice_id"
						v-if="addForm.project_ids.length > 0 || addForm.execute_ids.length > 0">
						<el-select v-model="addForm.invoice_id" clearable placeholder="请选择" style='width: 100%;'>
							<el-option v-for="item in options.invoice_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="addForm.remark" placeholder="请填写备注" type="textarea" clearable></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addInvoice('SAVE')" :size='size'
						:disabled="invoiceSubmitDisabled">保存</el-button>
					<el-button type="danger" @click="addInvoice('SUBMIT')" :size='size'
						:disabled="invoiceSubmitDisabled">提交</el-button>
					<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			loading: true,
			tableloading: true,
			addFormVisiable: false,
			editFormVisiable: false,
			invoiceSubmitDisabled: false,
			activeName: 'first',
			size: 'mini',
			pickerOptions: {
				disabledDate (time) {
					// 获取今天的日期
					const today = new Date();
					today.setHours(0, 0, 0, 0); // 设置时间为00:00:00:000
					return time.getTime() < today.getTime(); // 禁用今天之前的日期
				}
			},
			options: {
				cityOptions: ['PDF', 'OFD', 'XML'],
				invoice_type_options: [
					{
						value: 1,
						label: '普票'
					}, {
						value: 2,
						label: '专票'
					}, {
						value: 3,
						label: '形式发票'
					}
				],
				business_type_options: [
					{
						value: 1,
						label: '返点收入'
					}, {
						value: 2,
						label: '项目收入'
					}
				],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '被驳回'
					}, {
						value: 4,
						label: '正常'
					}
				],
				customer_id_options: [],//客户下拉
				project_ids_options: [],//项目下拉
				invoice_item_options: [],//发票类目
				invoice_id_options: [],//发票类型
				supplier_id_options: [],//供应商下拉
				execute_ids_options: []//执行下拉
			},
			searchForm: {
				// project_code: '',
				// project_name: '',
				invoice_code: '',
				shoupiaofang: '',
				business_type: '',
				execute_code: '',
				customer_id: '',
				supplier_id: '',
				invoice_type: '',
				invoice_item: '',
				open_invoice_time: [],
				status: '',
				open_invoice_user_name: '',
				invoice_number: ''
			},
			resetSearch: {
				// project_code: '',
				// project_name: '',
				invoice_code: '',
				shoupiaofang: '',
				business_type: '',
				execute_code: '',
				customer_id: '',
				supplier_id: '',
				invoice_type: '',
				invoice_item: '',
				open_invoice_time: [],
				status: '',
				open_invoice_user_name: '',
				invoice_number: ''
			},
			addForm: {
				id: '',
				customer_id: '',
				supplier_id: '',
				execute_ids: [],
				project_ids: [],
				invoice_open_list: [{
					id: '',
					open_price: '',
					code: ''
				}],
				invoice_types: [],
				open_type: '',
				payment_date: '',
				business_type: '',
				invoice_item: '',
				invoice_id: ''
			},
			rules: {
				addForm: {
					'customer_id': [
						{ required: true, message: '请选择客户', trigger: ['change'] }
					],
					'supplier_id': [
						{ required: true, message: '请选择供应商', trigger: ['change'] }
					],
					'project_ids': [
						{ required: true, message: '请选择项目', trigger: ['change'] }
					],
					'execute_ids': [
						{ required: true, message: '请选择执行', trigger: ['change'] }
					],
					'open_type': [
						{ required: true, message: '请选择开具类型', trigger: ['change'] }
					],
					'payment_date': [
						{ required: true, message: '请选择预计回款时间', trigger: ['change'] }
					],
					'business_type': [
						{ required: true, message: '请选择业务类型', trigger: ['change'] }
					],
					'invoice_types': [
						{ required: true, message: '请选择电子发票类型', trigger: ['change'] }
					],
					'invoice_item': [
						{ required: true, message: '请选择发票类目', trigger: ['change'] }
					],
					'invoice_id': [
						{ required: true, message: '请选择发票类型', trigger: ['change'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			invoice_open_list: [],//发票信息集合
			invoice_tips: ''//发票提示
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	watch: {
	},
	mounted: function () {
		//this.handleSearch(this.searchForm);
		this.getInvoicecategory()//获取发票类目
	},
	methods: {
		editOpenInvoice (row) {
			// 获取开票信息单条详情
			this.$api.get('/admin/resources/resources/getopeninviceinfo', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.$set(this, 'addForm', JSON.parse(JSON.stringify(res.data)))
					this.addFormVisiable = true
					if (res.data.business_type == 1) {
						this.getSupplier(res.data.name)//获取供应商
						this.getSupplierlist(() => {
							this.$set(this.addForm, 'execute_ids', res.data.execute_ids)
							this.$set(this.addForm, 'invoice_open_list', res.data.invoice_open_list)
							this.$set(this, 'invoice_open_list', res.data.invoice_open_list)

						})
					} else {
						this.getCustomer(res.data.name)//获取客户下拉
						this.getProjectlist('', () => {
							this.$set(this.addForm, 'project_ids', res.data.project_ids)
							this.$set(this.addForm, 'invoice_open_list', res.data.invoice_open_list)
							this.$set(this, 'invoice_open_list', res.data.invoice_open_list)
						})
					}
					this.getCusinvoicetype()
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		changeSearchType (val) {
			this.searchForm.execute_code = ''
			if (val == 1) {
				this.searchForm.customer_id = ''
				this.getSupplier()
			} else if (val == 2) {
				this.searchForm.supplier_id = ''
				this.getCustomer()
			}
		},
		returnCost () {
			return this.addForm.invoice_open_list.reduce((acc, item) => acc + Number(item.open_price), 0).toFixed(2)
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		validatorLrId (rule, value, callback) {
			let result = rule.field.match(/\[(.*?)\]/);
			let index = result[1]
			if (!value) {
				callback('请填写使用金额')
			} else {
				if (!isNaN(Number(value)) && value > 0) {
					//开票申请-实时验证项目可开票金额
					if (this.addForm.business_type == 1) {
						this.$api.get('/admin/resources/resources/checkopenex', { execute_id: this.addForm.invoice_open_list[index].id, price: this.addForm.invoice_open_list[index].open_price }).then(res => {
							if (res.code === 0) {
								callback()
							} else {
								callback(res.msg)
							}
						})
					} else {
						this.$api.get('/admin/resources/resources/chekopenip', { project_id: this.addForm.invoice_open_list[index].id, price: this.addForm.invoice_open_list[index].open_price }).then(res => {
							if (res.code === 0) {
								callback()
							} else {
								callback(res.msg)
							}
						})
					}

				} else {
					callback('使用金额必须为数字且必须大于0')
				}
			}
		},
		handleSearch: function (params, page, prop, order) {
			this.tableloading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/resources/resources/openinvicelist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.tableloading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		//获取客户下拉
		getCustomer (query) {
			this.$api.get('/admin/customers/customer/getcustomerselect', { 'query': query }).then(res => {
				if (res.code === 0) {
					this.options.customer_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取供应商下拉
		getSupplier (query) {
			this.$api.get('/admin/resources/resources/supldwn', { 'query': query, 'is_geren': 'NO' }).then(res => {
				if (res.code === 0) {
					this.options.supplier_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取发票类目列表
		getInvoicecategory (query) {
			this.$api.get('/admin/resources/resources/invoicecategory', { 'query': query }).then(res => {
				if (res.code === 0) {
					this.options.invoice_item_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//选择客户后获取对应的项目下拉
		getProjectlist (query, fun) {
			this.addForm.project_ids = []
			this.addForm.invoice_open_list = [{
				id: '',
				open_price: '',
				code: ''
			}]
			this.invoice_tips = ''
			this.$api.get('/admin/resources/resources/openip', { 'customer_id': this.addForm.customer_id, query: query }).then(res => {
				if (res.code === 0) {
					this.options.project_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
			if (typeof fun === 'function') {
				fun();
			}
		},
		getProjectlistSearch (query) {
			this.$api.get('/admin/resources/resources/openip', { 'customer_id': this.addForm.customer_id, query: query }).then(res => {
				if (res.code === 0) {
					this.options.project_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		getSupplierSearch (query) {
			this.$api.get('/admin/resources/resources/openex', { 'supplier_id': this.addForm.supplier_id, query: query }).then(res => {
				if (res.code === 0) {
					this.options.execute_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//选择供应商后获取对应的执行下拉
		getSupplierlist (fun) {
			this.addForm.execute_ids = []
			this.addForm.invoice_open_list = [{
				id: '',
				open_price: '',
				code: ''
			}]
			this.invoice_tips = ''
			this.$api.get('/admin/resources/resources/openex', { 'supplier_id': this.addForm.supplier_id }).then(res => {
				if (res.code === 0) {
					this.options.execute_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
			if (typeof fun === 'function') {
				fun();
			}
		},
		//选择项目后获取关联的客户发票类型列表
		getCusinvoicetype () {
			let param = {}
			if (this.addForm.business_type == 1) {
				param.supplier_id = this.addForm.supplier_id
			} else {
				param.customer_id = this.addForm.customer_id
			}
			this.$api.get('/admin/resources/resources/cusinvoicetype', param).then(res => {
				if (res.code === 0) {
					this.options.invoice_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//根据所选项目生成对应表格数据
		addInvoiceIds () {
			this.invoice_tips = ''
			if (this.addForm.business_type == 1) {
				this.$api.get('/admin/resources/resources/openex', { 'public_id': this.addForm.execute_ids }).then(res => {
					if (res.code === 0) {
						// this.options.execute_ids_options = res.data;
						//供应商
						let filteredOptions = res.data.filter(opt => this.addForm.execute_ids.includes(opt.value));
						this.invoice_open_list = filteredOptions.map(item => ({ id: item.value, code: item.code, open_price: item.price }));
						this.addForm.invoice_open_list = filteredOptions.map(item => ({ id: item.value, code: item.code, open_price: item.price }));
						//获取执行剩余可开票金额
						if (this.addForm.execute_ids.length > 0) {
							this.$api.get('/admin/resources/resources/exinfo', { execute_ids: this.addForm.execute_ids }).then(res => {
								if (res.code === 0) {
									this.invoice_tips = res.msg
								} else {
									this.$message.error(res.msg);
								}
							})
							this.getCusinvoicetype()//获取发票类型
						} else {
							this.execute_tips = ''
						}
					}
				})

			} else if (this.addForm.business_type == 2) {
				this.$api.get('/admin/resources/resources/openip', { 'public_id': this.addForm.project_ids }).then(res => {
					if (res.code === 0) {
						// this.options.project_ids_options = res.data;
						//客户
						let filteredOptions = res.data.filter(opt => this.addForm.project_ids.includes(opt.value));
						this.invoice_open_list = filteredOptions.map(item => ({ id: item.value, code: item.code, open_price: item.price }));
						this.addForm.invoice_open_list = filteredOptions.map(item => ({ id: item.value, code: item.code, open_price: item.price }));
						//获取项目剩余可开票金额
						if (this.addForm.project_ids.length > 0) {
							this.$api.get('/admin/resources/resources/piinfo', { project_ids: this.addForm.project_ids }).then(res => {
								if (res.code === 0) {
									this.invoice_tips = res.msg
								} else {
									this.$message.error(res.msg);
								}
							})
							this.getCusinvoicetype()//获取发票类型
						} else {
							this.execute_tips = ''
						}
					}
				})

			}

		},
		//切换业务类型
		changeType () {
			this.addForm.customer_id = ''
			this.addForm.supplier_id = ''
			this.addForm.execute_ids = []
			this.addForm.project_ids = []
			this.addForm.invoice_open_list = [{
				id: '',
				open_price: '',
				code: ''
			}]
			this.addForm.open_type = ''
			this.addForm.payment_date = ''
			this.addForm.invoice_item = ''
			this.addForm.invoice_id = ''
			this.invoice_open_list = []
			this.invoice_tips = ''
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
		},
		// 申请收票弹窗
		addInvoiceOpen () {
			this.addForm = {
				id: '',
				customer_id: '',
				supplier_id: '',
				execute_ids: [],
				project_ids: [],
				invoice_open_list: [{
					id: '',
					open_price: '',
					code: ''
				}],
				invoice_types: [],
				open_type: '',
				payment_date: '',
				business_type: '',
				invoice_item: '',
				invoice_id: ''
			}
			this.invoice_open_list = []
			this.invoice_tips = ''
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.getCustomer()//获取客户下拉
			this.getSupplier()//获取供应商
			this.addFormVisiable = true;
		},
		// 申请收票
		addInvoice (type) {
			if (this.invoiceSubmitDisabled) return;
			this.addForm['submit_type'] = type
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.invoiceSubmitDisabled = true;
					if (this.addForm['id']) {
						this.$api.post('/admin/resources/resources/editinvoiceopen', this.addForm).then(res => {
							if (res.code === 0) {
								// 重新加载表格
								this.handleSearch();
								this.$message({
									showClose: true,
									message: type == 'SAVE' ? '开票申请修改成功!' : '开票申请修改并提交成功!',
									type: 'success'
								});
							} else {
								this.$message.error(res.msg);
							}
							this.invoiceSubmitDisabled = false;
						}).catch(() => {
							this.invoiceSubmitDisabled = false;
						})
					} else {
						this.$api.post('/admin/resources/resources/invoiceopen', this.addForm).then(res => {
							if (res.code === 0) {
								// 重新加载表格
								this.handleSearch();
								this.$message({
									showClose: true,
									message: type == 'SAVE' ? '开票申请创建成功!' : '开票申请创建并提交成功!',
									type: 'success'
								});
							} else {
								this.$message.error(res.msg);
							}
							this.invoiceSubmitDisabled = false;
						}).catch(() => {
							this.invoiceSubmitDisabled = false;
						})
					}
					this.addFormVisiable = false;
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		addConfirmForm (row) {
			this.loading = true
			this.$api.post('/admin/resources/resources/submitopeninvice', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该申请已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		handleDelete (row) {
			this.$confirm('此操作将永久删除该条申请, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/resources/resources/delopeninvice', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该申请已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'OpenDetail',
				query: { id: row.id, set_id: 9, type: 'detail' }
			});
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/openDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>
<style type="text/css" scoped>
.el-table .el-form-item--mini.el-form-item,
.el-table .el-form-item--small.el-form-item {
	margin-bottom: 0;
}
</style>